export default __webpack_public_path__ + "b56dcdee357bad4a124907a4c489e5d2.svg";